"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
exports.acceptableDenominations = [1, 5, 10, 25, 100, 200, 500, 1000, 2000, 5000, 10000];
var CreateCashCount = /** @class */ (function () {
    function CreateCashCount() {
        var _this = this;
        this.setCashCount = function (state) {
            _this.cashCount = state === 'default'
                ? _this.defaultCashCount
                : null;
        };
        this.setCashCountItem = function (denominator, count) {
            if (_this.cashCount === null || isNaN(denominator)) {
                return;
            }
            _this.cashCount[denominator] = count;
        };
        this.cashCount = this.defaultCashCount;
    }
    Object.defineProperty(CreateCashCount.prototype, "isCashCountFilled", {
        get: function () {
            var thisCashCount = this.cashCount;
            if (thisCashCount === null) {
                return false;
            }
            return exports.acceptableDenominations.some(function (deno) { return thisCashCount[deno] !== null; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateCashCount.prototype, "defaultCashCount", {
        get: function () {
            var defaultCashCount = {};
            exports.acceptableDenominations.forEach(function (deno) {
                defaultCashCount[deno] = null;
            });
            return defaultCashCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateCashCount.prototype, "totalCashCount", {
        get: function () {
            var _this = this;
            var total = 0;
            if (this.cashCount === null) {
                return total;
            }
            exports.acceptableDenominations.forEach(function (deno) {
                var count = _this.cashCount[deno] || 0;
                total += deno * count;
            });
            return total;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], CreateCashCount.prototype, "cashCount", void 0);
    __decorate([
        mobx_1.action
    ], CreateCashCount.prototype, "setCashCount", void 0);
    __decorate([
        mobx_1.action
    ], CreateCashCount.prototype, "setCashCountItem", void 0);
    __decorate([
        mobx_1.computed
    ], CreateCashCount.prototype, "isCashCountFilled", null);
    __decorate([
        mobx_1.computed
    ], CreateCashCount.prototype, "defaultCashCount", null);
    __decorate([
        mobx_1.computed
    ], CreateCashCount.prototype, "totalCashCount", null);
    return CreateCashCount;
}());
exports.CreateCashCount = CreateCashCount;
var CreateEndShift = /** @class */ (function (_super) {
    __extends(CreateEndShift, _super);
    function CreateEndShift() {
        var _this = _super.call(this) || this;
        _this.registerPasscode = '';
        _this.setRegisterPasscode = function (registerPasscode) {
            _this.registerPasscode = registerPasscode;
        };
        return _this;
    }
    __decorate([
        mobx_1.observable
    ], CreateEndShift.prototype, "registerPasscode", void 0);
    __decorate([
        mobx_1.action
    ], CreateEndShift.prototype, "setRegisterPasscode", void 0);
    return CreateEndShift;
}(CreateCashCount));
exports.CreateEndShift = CreateEndShift;
//# sourceMappingURL=Shift.js.map